import { DOMAIN_LABELS, DOMAIN_ORDER, DOMAIN_SLUGS, byDomain } from "@csbi/metric-catalog"

export const SITE_NAME = "RegDesk"
export const SITE_SUBTITLE = "CLIENT SUCCESS-BI"

export const DOMAIN_NAV = DOMAIN_ORDER.map((domain) => ({
  domain,
  slug: DOMAIN_SLUGS[domain],
  label: DOMAIN_LABELS[domain],
  metricCount: byDomain.get(domain)?.length ?? 0,
}))

export const DOMAIN_BY_SLUG = new Map(DOMAIN_NAV.map((d) => [d.slug, d]))
